import React, { Fragment } from 'react'

const stripCharsFromTele = telNum =>
  telNum
    .replace('(', '')
    .replace(')', '')
    .replace('-', '')
    .replace(' ', '')

const parseSupportTelNums = (telNumStr, isOpen) => {
  if (telNumStr.indexOf('or')) {
    const telNumArr = telNumStr.split(' or ')

    return telNumArr.map((telNum, index) => (
      <Fragment key={`tel-${telNum}`}>
        <a
          aria-label={`contact customer service at ${telNum}`}
          className="tel help-panel-link"
          href={`tel:${stripCharsFromTele(telNum)}`}
          tabIndex={isOpen ? 0 : -1}
        >
          {telNum}
        </a>
        {index < telNumArr.length - 1 ? ' or ' : null}
      </Fragment>
    ))
  }

  return null
}

export default parseSupportTelNums
